import { createLightTheme, type BrandVariants, type Theme } from "@fluentui/react-components";

/**
 * IM アプリのブランドカラー (#A9855F) を基準にした Fluent UI v9 用 BrandVariants。
 *
 * 基本設計書 v1 [[1.2. UI・UX]] のブランドカラーを 80 に固定し、
 * 10〜70 はダーク方向、90〜160 はライト方向にウォームトーンを保ったまま展開する。
 *
 * ブランドカラー自体はロゴ・装飾用途に限定し、テキストやインタラクティブ要素には
 * 使わないという v1 の方針を踏襲する。
 */
const imBrand: BrandVariants = {
    10: "#1A1108",
    20: "#2F1F11",
    30: "#44301B",
    40: "#5A4225",
    50: "#715431",
    60: "#88663D",
    70: "#9C764B",
    80: "#A9855F",
    90: "#B5957A",
    100: "#C2A593",
    110: "#CEB6AB",
    120: "#DAC6BD",
    130: "#E0CFC8",
    140: "#EAD9D2",
    150: "#F0E8DF",
    160: "#F7F1EC",
};

/**
 * IM アプリ用のライトテーマ。
 *
 * Fluent UI v9 の `createLightTheme` をベースに、v1 のニュートラル系トークンを
 * 該当する Fluent トークンへ割り当て直している。Fluent 標準に存在しない
 * セマンティックトークン (page-bg / sidebar-bg / brand-light 等) は
 * {@link imCustomTokens} 経由で利用する。
 */
export const imLightTheme: Theme = {
    ...createLightTheme(imBrand),
    colorNeutralBackground1: "#FFFFFF",
    colorNeutralBackground2: "#F5F1EC",
    colorNeutralBackground3: "#E6E0D6",
    colorNeutralStroke1: "#C8C2BA",
    colorNeutralStroke2: "#8C8680",
    colorNeutralForeground1: "#2A2723",
    colorNeutralForeground2: "#645E58",
    colorNeutralForeground3: "#9E9890",
};

/**
 * Fluent UI v9 標準に存在しない、v1 由来のセマンティックトークン。
 * `makeStyles` 内では直接文字列リテラルを書かず、必ずここを参照する。
 */
export const imCustomTokens = {
    pageBg: "#F5F1EC",
    surface: "#FFFFFF",
    sidebarBg: "#E6E0D6",
    borderSubtle: "#C8C2BA",
    borderInput: "#8C8680",
    textPrimary: "#2A2723",
    textSecondary: "#645E58",
    textMuted: "#9E9890",
    brandLight: "#F0E8DF",
    brand: "#A9855F",
    brandDark: "#7A5E3E",
    interactive: "#488EE0",
    interactiveActive: "#1971C2",
    success: "#2A7A4B",
    danger: "#961533",
    dangerActive: "#C91C45",
} as const;
